import { render, staticRenderFns } from "./WebCaloriesStatisticalLog.vue?vue&type=template&id=4ca80a2d&scoped=true&"
import script from "./WebCaloriesStatisticalLog.vue?vue&type=script&lang=js&"
export * from "./WebCaloriesStatisticalLog.vue?vue&type=script&lang=js&"
import style0 from "./WebCaloriesStatisticalLog.vue?vue&type=style&index=0&id=4ca80a2d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca80a2d",
  null
  
)

export default component.exports